import useQueryGetter from "../queries/useQueryGetter";

/**
 *
 * @param url
 * @param [options]
 * @returns {{data: *, query: UseQueryResult<*, unknown>}}
 */
export default function useGetter(url, options = {}) {
  const query = useQueryGetter(url, options);

  let data = null;
  if (query?.data) {
    data = query?.data;
  }

  return { data, query };
}
